import { render } from "./RoleEdit.vue?vue&type=template&id=cc200230&ts=true"
import script from "./RoleEdit.vue?vue&type=script&lang=ts"
export * from "./RoleEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__